import { useQuery } from "@tanstack/react-query";

import { useAppInfo } from "@/features/auth/hooks/use-app-info";
import { workosAuthorizeOptions } from "@/openapi/@tanstack/react-query.gen";

export const useWorkosAuthorize = (state?: string) => {
  const { data: appInfo } = useAppInfo();
  const enabled = appInfo?.workos ?? false;

  const { data, isFetching } = useQuery({
    ...workosAuthorizeOptions({
      query: { state: state ?? null },
    }),
    enabled,
  });

  return {
    enabled,
    authorizationUrl: data?.authorization_url ?? null,
    isLoading: isFetching,
  };
};
